import React from 'react'
import ScrapEdit from "./ScrapEdit";
import {Button, Popconfirm} from "antd";
import {deleteScrap} from "../../services/serviceScrap";

const ScrapActions = ({record, updater}) => {

    const handleDeleteClick = () => {
        deleteScrap(record.id)
            .then(() => updater())
    }

    return(
        <React.Fragment>
            <ScrapEdit record={record} updater={updater}/>
            <Popconfirm
                title={'Silmek istediğinize emin misiniz ?'}
                okText={'SİL'}
                cancelText={'VAZGEÇ'}
                okButtonProps={{type: 'danger'}}
                onConfirm={handleDeleteClick}
            >
                <Button type={"link"} danger>
                    Sil
                </Button>
            </Popconfirm>
        </React.Fragment>
    )
}
export default ScrapActions